<template>
  <transition name="rl-fade">
    <div v-if="visible" class="rl-overlay">
      <div class="rl-card">
        <div class="rl-hearts">
          <svg v-for="n in 3" :key="n" class="rl-heart" :style="heartStyle(n)" viewBox="0 0 40 40" fill="none">
            <path d="M20 34s-12-7.4-12-16a7 7 0 0 1 12-4.9A7 7 0 0 1 32 18c0 8.6-12 16-12 16z" fill="url(#rl-g)"/>
            <defs>
              <linearGradient id="rl-g" x1="8" y1="8" x2="32" y2="34">
                <stop stop-color="#ff4d8d"/><stop offset="1" stop-color="#a020f0"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div class="rl-label">{{ label }}</div>
        <div class="rl-bar"><div class="rl-bar__fill"></div></div>
      </div>
    </div>
  </transition>
</template>

<script>
// Fancy route-transition loader — minimum 280ms so it doesn't flicker on fast navigations.
const LABELS = {
  home:           'Getting your feed…',
  video:          'Tuning in…',
  chats:          'Opening messages…',
  'chat-thread':  'Opening chat…',
  choose:         'Finding matches…',
  discover:       'Lining up picks…',
  matches:        'Loading matches…',
  Lottery:        'Loading rewards…',
  mine:           'Loading your profile…',
  Infomation:     'Loading your profile…',
  Setting:        'Opening settings…',
  Setname:        'Opening name…',
  Setsex:         'Opening gender…',
  Language:       'Opening language…',
  Recharge:       'Opening top-up…',
  SetPayPassword: 'Opening PIN…',
  SetLoginPassword:'Opening password…',
  Notice:         'Loading notices…',
  Setbank:        'Opening wallet…',
  BindCard:       'Opening wallet…',
  Withdraw:       'Opening withdrawal…',
  Personalreport: 'Loading stats…',
  WithdrawRecord: 'Loading history…',
  GameRecord:     'Loading history…',
  Details:        'Loading profile…',
  ServiceOnline:  'Opening support…',
  ServicePage:    'Opening support…',
  PlayVideo:      'Starting playback…',
  login:          'Heading to sign-in…',
  register:       'Heading to sign-up…',
  landing:        'Welcome back…'
};

export default {
  name: 'RouteLoader',
  data(){
    return { visible: false, label: 'Loading…' };
  },
  mounted(){
    if(!window.$km) window.$km = {};
    window.$km.routeLoader = {
      show: (to) => this.show(to),
      hide: () => this.hide()
    };
  },
  beforeDestroy(){
    if(window.$km && window.$km.routeLoader) delete window.$km.routeLoader;
    clearTimeout(this.$options._hideT);
  },
  methods: {
    show(to){
      const routeName = (to && to.name) || '';
      this.label = LABELS[routeName] || 'Loading…';
      this.visible = true;
      this.$options._shownAt = Date.now();
      clearTimeout(this.$options._hideT);
    },
    hide(){
      // Keep the overlay up for at least 280ms so it feels intentional
      const elapsed = Date.now() - this.$options._shownAt;
      const remaining = Math.max(0, 280 - elapsed);
      clearTimeout(this.$options._hideT);
      this.$options._hideT = setTimeout(() => { this.visible = false; }, remaining);
    },
    heartStyle(n){
      return { animationDelay: ((n - 1) * 0.16) + 's' };
    }
  }
};
</script>

<style scoped>
.rl-overlay {
  position: fixed; inset: 0; z-index: 9990;
  display: flex; align-items: center; justify-content: center;
  pointer-events: none;
  background: rgba(253, 245, 249, 0.55);
  backdrop-filter: blur(6px) saturate(140%);
  -webkit-backdrop-filter: blur(6px) saturate(140%);
}
.rl-card {
  display: flex; flex-direction: column; align-items: center; gap: 14px;
  padding: 22px 28px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(255, 77, 141, 0.18);
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(160, 32, 240, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  color: #2a1a3f;
}
.rl-hearts { display: flex; align-items: center; gap: 8px; }
.rl-heart {
  width: 26px; height: 26px;
  animation: rl-beat 1.1s cubic-bezier(.2,.9,.3,1.2) infinite;
  filter: drop-shadow(0 4px 10px rgba(255, 77, 141, 0.3));
}
@keyframes rl-beat {
  0%, 100% { transform: scale(.78); opacity: .55; }
  30%      { transform: scale(1.12); opacity: 1; }
  55%      { transform: scale(.9);  opacity: .8; }
}
.rl-label {
  font-size: 13px; font-weight: 700; letter-spacing: .01em;
  color: #5a4a78;
}
.rl-bar {
  width: 140px; height: 4px; border-radius: 2px;
  background: rgba(255, 77, 141, 0.12); overflow: hidden;
}
.rl-bar__fill {
  height: 100%; width: 40%;
  background: linear-gradient(90deg, #ff4d8d, #a020f0);
  border-radius: 2px;
  animation: rl-slide 1.1s cubic-bezier(.4,0,.2,1) infinite;
}
@keyframes rl-slide {
  0%   { transform: translateX(-120%); }
  100% { transform: translateX(320%); }
}

/* Smooth in/out */
.rl-fade-enter-active { transition: opacity .18s ease-out; }
.rl-fade-leave-active { transition: opacity .22s ease-in; }
.rl-fade-enter, .rl-fade-leave-to { opacity: 0; }

@media (max-width: 520px) {
  .rl-card { padding: 18px 22px; gap: 12px; }
  .rl-heart { width: 22px; height: 22px; }
  .rl-label { font-size: 12px; }
  .rl-bar { width: 120px; }
}
</style>
